import {placeholderQuestion} from './questionTemplates'

export function newQuestionInSet(indexOfNewQuestion,currentSet,copiedQuestion) {
	const newQuestion =placeholderQuestion()

	if(copiedQuestion){
		newQuestion.body=copiedQuestion.body
		newQuestion.choices=copiedQuestion.choices
		newQuestion.xLayout=copiedQuestion.xLayout
		newQuestion.template=copiedQuestion.template
		newQuestion.image=copiedQuestion.image
	}


	const randId='00000000'.replace(/0/g,function(){return (~~(Math.random()*16)).toString(16)})
	newQuestion.questionId=randId

	return newQuestion

}

